import { io } from 'socket.io-client';

var socket = null;
var socketToken = '';

function getSocket() {
  var token = localStorage.getItem('autodoc_token') || '';
  // 토큰이 바뀌면(회사 전환/재로그인) 옛 인증으로 붙은 소켓은 버린다.
  if (socket && socketToken !== token) {
    try { socket.disconnect(); } catch(e) {}
    socket = null;
    socketToken = '';
  }
  // 연결 완료 전(connecting)에도 같은 인스턴스를 재사용 — connected 조건이면
  // 첫 진입 시 Manager 가 중복 생성되어 WS 다중 연결 + room join 팬아웃 발생.
  if (socket) return socket;
  if (!token) return null;
  // Phase 2: REACT_APP_API_BASE 우선 (도메인 분리 후 api.autodex.kr 로 WebSocket 연결)
  var _envBase = (process.env.REACT_APP_API_BASE || '').replace(/\/+$/, '');
  var _runtimeBase = process.env.NODE_ENV === 'production' ? window.location.origin : 'http://localhost:4000';
  var url = _envBase || _runtimeBase;
  try {
    socket = io(url, {
      auth: { token: token },
      transports: ['websocket', 'polling'],
      reconnectionAttempts: 5,
      reconnectionDelay: 3000
    });
    socket.on('connect_error', function() {});
    socketToken = token;
  } catch(e) {
    socket = null;
    socketToken = '';
  }
  return socket;
}

function disconnectSocket() {
  if (socket) {
    try { socket.disconnect(); } catch(e) {}
    socket = null;
  }
  socketToken = '';
}

export { getSocket, disconnectSocket };
